//============================
//# mlgenpartprod
//============================

import { ValidationRules } from "@/models/Validation";

export default interface PartProdRelation {
  id: number;
  partner: number;
  prodType: number;
  prodTypeName: string;
  region: number;
  regionName: string;
  isTax: boolean;
  partner2: number | null;
  taxId: number | null;
  prodNo: string;
  ocsgNo: string | null;
  taxNo: string;
  birthName: string | null;
  birthDate: Date | null;
  birthPlace: string | null;
  motherName: string | null;
  sex: boolean | null;
  sexName: string | null;
  tajNumber: string | null;
  nationality: string | null;
  felirNumber: string | null;
  nebihNumber: string | null;
  regNo: string | null;
  deleted: boolean;
  isProdTypeEditable: boolean;

  inEdit: boolean;
}

export const PartProdRelationDefaultProps: PartProdRelation = {
  id: 0,
  partner: 1,
  prodType: 1,
  prodTypeName: "-",
  region: 1,
  regionName: "-",
  isTax: false,
  partner2: null,
  taxId: null,
  prodNo: "-",
  ocsgNo: null,
  taxNo: "-",
  birthName: "-",
  birthDate: null,
  birthPlace: "-",
  motherName: "-",
  sex: null,
  sexName: null,
  tajNumber: null,
  nationality: "-",
  felirNumber: "-",
  nebihNumber: "-",
  regNo: null,
  deleted: false,
  isProdTypeEditable: false,

  inEdit: false,
}

export const PartProdRelationValidationRules: ValidationRules = {
  birthName: [
    (v: string) => !!v || "Kötelező",
    (v: string) => v.replace(/\s+/g, "").length >= 4 || "Nem lehet rövidebb, mint 4 karakter",
  ],
  motherName: [
    (v: string) => !!v || "Kötelező",
    (v: string) => v.replace(/\s+/g, "").length >= 4 || "Nem lehet rövidebb, mint 4 karakter",
  ],
  nationality: [
    (v: string) => !!v || "Kötelező",
    (v: string) => v.replace(/\s+/g, "").length >= 2 || "Nem lehet rövidebb, mint 2 karakter",
  ],
  prodNo: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{7}$").test(v)) || "Rossz formátum (1234567)",
  ],
  ocsgNo: [
    (v: string) => (v.length == 0 || new RegExp("^\\d{8}$").test(v)) || "Rossz formátum (12345678)",
  ],
  taxNo: [
    (v: string) => !!v || "Kötelező",
    // (v: string) => new RegExp("^\\d{10}$").test(v) || "Rossz formátum (1234567890)",
  ],
  felirNumber: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^[A-Z]{2}\\d{7}$").test(v)) || "Rossz formátum (AB1234567)",
  ],
  nebihNumber: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{10}$").test(v)) || "Rossz formátum (1234567890)",
  ],
  tajNumber: [
    (v: string) => !!v || "Kötelező",
    (v: string) => new RegExp("^\\d{9}$").test(v) || "Rossz formátum (123456789)",
 ],  
 regNo: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{10}$").test(v)) || "Rossz formátum (1234567890)",
 ],
}